<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line clickable" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-line--right">
        <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
          <i class="material-icons">search</i>
        </div>
        <div class="ir-btn th-btn-normal" (click)="openMenu()">
          <i class="material-icons">more_vert</i>
        </div>
      </div>
    </div>
    <div class="ir-line-content">
      <span
        >Observation <strong>({{ actionPlanItem?.plugins?.length + 1 }})</strong></span
      >
    </div>
    <div class="ir-popup th-popup">
      <span
        ><strong>{{ actionPlan?.inspection?.name }}</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="query"
        focus="showSearch"
      />
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <action-plan-item-detail
    [processing]="processing"
    [showHelp]="showHelp"
    [actionPlan]="actionPlan"
    [actionPlanItem]="actionPlanItem"
    (toggleUpdateStatus)="updateStatus($event)"
    (toggleCancel)="cancel()"
    [query]="query"
  ></action-plan-item-detail>
</div>

<modal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePoint($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete action plan item?'"
  [danger]="true"
></confirm>
